(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      }
  
      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
  
      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
  
        this.hidePanel();
        this.elements.button.focus();
      }
  
      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
  
      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      }
  
      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
          this.hidePanel();
        }
      }
    }
  
    customElements.define('localization-form', LocalizationForm);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presale-code"] && !window.DesignMode) return;
  try {
    
  class PresaleCodeReadout extends HTMLElement {
  constructor(){
    super();
    this.presaleCode = false
    this.codeRetrievalAttempts = 0
    this.maxRetries = 10
    this.retryFactor = 5

    this.helpTextUpdateInterval = 0
    this.loadingMessageText = "Loading your code.. Just a sec."
  } 
  
  connectedCallback(){
    this.codeRetrievalUrl = this.getAttribute("code-retrieval-url")
    this.render();
  }

  moreRetriesPossible(){
    return this.codeRetrievalAttempts < this.maxRetries
  }
  
  retryCodeRetrieval() {
    if(!this.moreRetriesPossible()) {
      console.log("Giving up on retries")
      window.clearInterval(this.helpTextUpdateInterval)
      this.updateErrorText()
      return
    }
    
    const msToWait = (2 ** this.codeRetrievalAttempts * this.retryFactor) * 1000
    this.nextRetryAttemptAt = (new Date()).getTime() + msToWait
    console.log("Starting retry loop, Waiting...", msToWait)
    window.setTimeout(this.loadPresaleCode.bind(this), msToWait)

    if(!this.helpTextUpdateInterval) {
      this.helpTextUpdateInterval = window.setInterval(this.updateErrorText.bind(this), 1000)  
    }
  }
  
  async loadPresaleCode() {
    try {
      this.codeRetrievalAttempts++
      this.textContent = this.loadingMessageText

      if(window.location.hash.includes('test__code-retrieve-fail')) {
        throw "Code retrieval failed because the URL indicates you wanted to test the error scenario."
      }
      
      const fetchResult = await fetch(this.codeRetrievalUrl)
      const apiResponse = await fetchResult.json()
      if(!apiResponse || apiResponse.error) {
        return this.onPresaleCodeError(apiResponse.error)
      }
      this.presaleCode = apiResponse.code_string.trim()
      this.onPresaleCodeRetrieved()
    } catch(e) {
      this.onPresaleCodeError(e.message)
    }
  }

  updateErrorText() {
    var contactFormUrl = '/pages/contact#contact-template--15944059060412__form'
    if(this.moreRetriesPossible()){
      var timeTilNextRetry = Math.floor((this.nextRetryAttemptAt - (new Date()).getTime()) / 1000)
      var timesTriedText = `${this.codeRetrievalAttempts} time`
      if(this.codeRetrievalAttempts > 1) {
        timesTriedText += "s"
      }
      var nextStepsMessage = `Hold on. We've tried ${timesTriedText}, but we'll try again in ${timeTilNextRetry} seconds...`
    } else {
      var nextStepsMessage = `Sorry, we tried ${this.codeRetrievalAttempts} times but it's still not working.<br/>You can <a href='?'>refresh the page to try again</a>, or <a href='${contactFormUrl}'>click here to contact us for help.</a>`
    }

    this.errorTextContainer.innerHTML = nextStepsMessage
  }

  onPresaleCodeRetrieved() {
    //console.log("Presale code retrieved")
    this.innerHTML = `<h2>Your Unique Pre-Sale Code is<strong class="presale-code-string">${this.presaleCode}</strong></h2><p>Don't share this code: it's unique to you and can only be used once.</p>`
    this.setAttribute('data-presale-code', this.presaleCode)

    this.dispatchEvent(
      new CustomEvent("presale-code:available", {
        bubbles: true,
        detail: { presaleCode: () => this.presaleCode },
      })
    );
  }
  onPresaleCodeError(errorMessage) {
    this.innerHTML = `<h4>Oh no! An unexpected error occurred when fetching your presale code.</h4>`

    this.errorTextContainer = document.createElement('span')
    this.errorTextContainer.classList.add('presale-retrieval-error-status')
    this.appendChild(this.errorTextContainer)
    
    this.retryCodeRetrieval()
  }
  
  render(){
    this.textContent = this.loadingMessageText
    this.loadPresaleCode()
  }
}
window.customElements.define('presale-code-readout', PresaleCodeReadout);

  } catch(e) { console.error(e); }
})();
})();
